import styled, { css } from 'styled-components'

import { SPACING as constants } from '../../constants'

import BaseCard from '../../lib/components/Card'
import Typography from '../../lib/typography'

// prettier-ignore
/** @param {{ nested?: number }} props */
const nestedStyles = props => props.nested && css`
  background-color: #f1f1f1;

  > * {
    margin-left: ${props.nested * 24}px !important;
    color: #828282;
  }
`

const columnGrid = css`
  padding: 0 ${constants.GAP};
  display: grid;
  align-items: center;
`

/**
 * @param {ReturnType<typeof css>} moreStyles
 */
export const createTableCard = moreStyles => ({
  Root: styled(BaseCard)`
    width: 100%;
  `,
  Heading: styled.div`
    height: 30px;
    background-color: #cccccc;

    ${columnGrid}
    ${moreStyles}

    ${Typography.Data} {
      color: #404040;
    }
  `,
  Container: styled.div`
    height: 45px;
    border-bottom: 1px solid #e6e6e6;

    ${columnGrid}
    ${nestedStyles}
    ${moreStyles}
  `,
})

export default createTableCard(css``)



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/TableCard.jsx